import { CCol, CContainer, CRow, CSpinner } from '@coreui/react';
import React, { useEffect, useState } from 'react';

export const PageLoading = (props: { details?: string }) => {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowMessage(true);
    }, 1000);
  }, []);

  return (
    <>
      <div className="body flex-grow-1" id="placeholderPageLoading">
        <CContainer className="px-4" lg>
          <CRow>
            <CCol>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CSpinner variant="grow" />
                {!!props?.details && showMessage && (
                  <>
                    <span className="m-3">{props.details} ...</span>
                  </>
                )}
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </>
  );
};
